import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { deleteaccountgroup, listaccountgroups } from "../../../../services/admin";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { isAdmin } from "../../../../utils/roles";

export default function AllAccountGroups() {
    const [accountGroups, setAccountGroups] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetchAccountGroups();
    }, []);

    const fetchAccountGroups = () => {
        listaccountgroups().then((res) => {
            if (res.status === true) {
                setAccountGroups(res.data);
            }
        });
    };

    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 140,
            sortable: false,
            resizable: false,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "center" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        {isAdmin() && (
                            <>
                                <a
                                    onClick={() => navigate(`/master/editaccountgroup/${params.value}`)}
                                    className="btn-sm btn-info me-2"
                                    title="Edit Account Group"
                                >
                                    <i className="fa fa-edit"></i>
                                </a>
                                {!params.data.is_system && (
                                    <a
                                        onClick={() => handleDelete(params.value)}
                                        className="btn-sm btn-danger me-2"
                                        title="Delete Account Group"
                                    >
                                        <i className="fa fa-trash"></i>
                                    </a>
                                )}
                            </>
                        )}
                    </div>
                );
            },
        },
        {
            headerName: "Group Name",
            field: "group_name",
            width: 200,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Group Code",
            field: "group_code",
            width: 150,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Account Type",
            field: "account_type.type_name",
            width: 150,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            valueGetter: function (params) {
                return params.data.account_type ? params.data.account_type.type_name : "-";
            },
        },
        {
            headerName: "Description",
            field: "description",
            width: 300,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Status",
            field: "is_active",
            width: 120,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "center" },
            cellRenderer: function (params) {
                return params.value
                    ? <span className="badge bg-success">Active</span>
                    : <span className="badge bg-secondary">Inactive</span>;
            },
        },
        {
            headerName: "System Group",
            field: "is_system",
            width: 120,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "center" },
            cellRenderer: function (params) {
                return params.value
                    ? <span className="badge bg-warning">System</span>
                    : <span className="badge bg-info">Custom</span>;
            },
        },
    ];

    const handleDelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this account group?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                deleteaccountgroup(id).then((res) => {
                    if (res.status === true) {
                        toast.success(res.message);
                        fetchAccountGroups();
                    } else {
                        toast.error(res.message);
                    }
                });
            }
        });
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Account Groups</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Master</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Account Groups
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className='d-flex justify-content-end'>
                                <a className='btn btn-success' onClick={() => navigate("/master/addaccountgroup")}> <i className="fa fa-plus me-2"></i>Add Account Group</a>
                            </div>
                            <div className="card-body">
                                <div className="ag-theme-alpine" style={{ height: 600, width: "100%" }}>
                                    <AgGridReact
                                        rowData={accountGroups}
                                        columnDefs={columnDefs}
                                        defaultColDef={{
                                            sortable: true,
                                            resizable: true,
                                        }}
                                        pagination={true}
                                        paginationPageSize={10}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
